import { render, staticRenderFns } from "./GuidePage.vue?vue&type=template&id=10b564e8&scoped=true"
import script from "./GuidePage.vue?vue&type=script&lang=ts"
export * from "./GuidePage.vue?vue&type=script&lang=ts"
import style0 from "./GuidePage.vue?vue&type=style&index=0&id=10b564e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b564e8",
  null
  
)

export default component.exports